/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './static-timeline-demo.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../shared/panel/panel.component.ngfactory';
import * as i3 from '../../../../src/app/shared/panel/panel.component';
import * as i4 from '../shared/static-timeline/static-timeline.component.ngfactory';
import * as i5 from '../../../../src/app/shared/static-timeline/static-timeline.component';
import * as i6 from '../shared/grid/grid.component.ngfactory';
import * as i7 from '../../../../src/app/shared/grid/grid.component';
import * as i8 from '../../../../src/app/static-timeline/static-timeline-demo.component';
const styles_StaticTimelineDemoComponent:any[] = [i0.styles];
export const RenderType_StaticTimelineDemoComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_StaticTimelineDemoComponent,data:{}});
function View_StaticTimelineDemoComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'admin-panel',
      ([] as any[]),[[2,'tabbed',(null as any)],[2,'minimized',(null as any)],[2,'closed',
          (null as any)]],(null as any),(null as any),i2.View_PanelComponent_0,i2.RenderType_PanelComponent)),
      i1.ɵdid(4767744,(null as any),0,i3.PanelComponent,([] as any[]),(null as any),
          (null as any)),(_l()(),i1.ɵeld(0,(null as any),1,2,'admin-static-timeline',
          ([] as any[]),[[2,'dark-mode',(null as any)]],(null as any),(null as any),
          i4.View_StaticTimelineComponent_0,i4.RenderType_StaticTimelineComponent)),
      i1.ɵdid(638976,(null as any),1,i5.StaticTimelineComponent,([] as any[]),{events:[0,
          'events']},(null as any)),i1.ɵqud(603979776,2,{templates:1}),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),4,'admin-panel',([] as any[]),[[2,'tabbed',(null as any)],
              [2,'minimized',(null as any)],[2,'closed',(null as any)]],(null as any),
          (null as any),i2.View_PanelComponent_0,i2.RenderType_PanelComponent)),i1.ɵdid(4767744,
          (null as any),0,i3.PanelComponent,([] as any[]),(null as any),(null as any)),
      (_l()(),i1.ɵeld(0,(null as any),1,2,'admin-static-timeline',([] as any[]),[[2,
          'dark-mode',(null as any)]],(null as any),(null as any),i4.View_StaticTimelineComponent_0,
          i4.RenderType_StaticTimelineComponent)),i1.ɵdid(638976,(null as any),1,i5.StaticTimelineComponent,
          ([] as any[]),{events:[0,'events'],full:[1,'full']},(null as any)),i1.ɵqud(603979776,
          3,{templates:1})],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_4:any = _co.events;
    _ck(_v,3,0,currVal_4);
    const currVal_9:any = _co.events;
    const currVal_10:any = true;
    _ck(_v,8,0,currVal_9,currVal_10);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1).tabbed;
    const currVal_1:any = i1.ɵnov(_v,1).isMinimized;
    const currVal_2:any = i1.ɵnov(_v,1).isClosed;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
    const currVal_3:any = i1.ɵnov(_v,3).darkMode;
    _ck(_v,2,0,currVal_3);
    const currVal_5:any = i1.ɵnov(_v,6).tabbed;
    const currVal_6:any = i1.ɵnov(_v,6).isMinimized;
    const currVal_7:any = i1.ɵnov(_v,6).isClosed;
    _ck(_v,5,0,currVal_5,currVal_6,currVal_7);
    const currVal_8:any = i1.ɵnov(_v,8).darkMode;
    _ck(_v,7,0,currVal_8);
  });
}
function View_StaticTimelineDemoComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'admin-panel',
      ([] as any[]),[[2,'tabbed',(null as any)],[2,'minimized',(null as any)],[2,'closed',
          (null as any)]],(null as any),(null as any),i2.View_PanelComponent_0,i2.RenderType_PanelComponent)),
      i1.ɵdid(4767744,(null as any),0,i3.PanelComponent,([] as any[]),(null as any),
          (null as any)),(_l()(),i1.ɵeld(0,(null as any),1,2,'admin-static-timeline',
          ([] as any[]),[[2,'dark-mode',(null as any)]],(null as any),(null as any),
          i4.View_StaticTimelineComponent_0,i4.RenderType_StaticTimelineComponent)),
      i1.ɵdid(638976,(null as any),1,i5.StaticTimelineComponent,([] as any[]),{events:[0,
          'events'],block:[1,'block']},(null as any)),i1.ɵqud(603979776,4,{templates:1}),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),4,'admin-panel',([] as any[]),
          [[2,'tabbed',(null as any)],[2,'minimized',(null as any)],[2,'closed',(null as any)]],
          (null as any),(null as any),i2.View_PanelComponent_0,i2.RenderType_PanelComponent)),
      i1.ɵdid(4767744,(null as any),0,i3.PanelComponent,([] as any[]),(null as any),
          (null as any)),(_l()(),i1.ɵeld(0,(null as any),1,2,'admin-static-timeline',
          ([] as any[]),[[2,'dark-mode',(null as any)]],(null as any),(null as any),
          i4.View_StaticTimelineComponent_0,i4.RenderType_StaticTimelineComponent)),
      i1.ɵdid(638976,(null as any),1,i5.StaticTimelineComponent,([] as any[]),{events:[0,
          'events'],block:[1,'block'],full:[2,'full']},(null as any)),i1.ɵqud(603979776,
          5,{templates:1})],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_4:any = _co.events;
    const currVal_5:any = true;
    _ck(_v,3,0,currVal_4,currVal_5);
    const currVal_10:any = _co.events;
    const currVal_11:any = true;
    const currVal_12:any = true;
    _ck(_v,8,0,currVal_10,currVal_11,currVal_12);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1).tabbed;
    const currVal_1:any = i1.ɵnov(_v,1).isMinimized;
    const currVal_2:any = i1.ɵnov(_v,1).isClosed;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
    const currVal_3:any = i1.ɵnov(_v,3).darkMode;
    _ck(_v,2,0,currVal_3);
    const currVal_6:any = i1.ɵnov(_v,6).tabbed;
    const currVal_7:any = i1.ɵnov(_v,6).isMinimized;
    const currVal_8:any = i1.ɵnov(_v,6).isClosed;
    _ck(_v,5,0,currVal_6,currVal_7,currVal_8);
    const currVal_9:any = i1.ɵnov(_v,8).darkMode;
    _ck(_v,7,0,currVal_9);
  });
}
export function View_StaticTimelineDemoComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),5,'admin-grid',([] as any[]),
      (null as any),(null as any),(null as any),i6.View_GridComponent_0,i6.RenderType_GridComponent)),
      i1.ɵdid(49152,(null as any),1,i7.GridComponent,([] as any[]),{cols:[0,'cols']},
          (null as any)),i1.ɵqud(603979776,1,{templates:1}),i1.ɵpad(2),(_l()(),i1.ɵand(0,
          [[1,2]],(null as any),0,(null as any),View_StaticTimelineDemoComponent_1)),
      (_l()(),i1.ɵand(0,[[1,2]],(null as any),0,(null as any),View_StaticTimelineDemoComponent_2))],
      (_ck,_v) => {
        const currVal_0:any = _ck(_v,3,0,6,6);
        _ck(_v,1,0,currVal_0);
      },(null as any));
}
export function View_StaticTimelineDemoComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'ng-component',
      ([] as any[]),(null as any),(null as any),(null as any),View_StaticTimelineDemoComponent_0,
      RenderType_StaticTimelineDemoComponent)),i1.ɵdid(49152,(null as any),0,i8.StaticTimelineDemoComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const StaticTimelineDemoComponentNgFactory:i1.ComponentFactory<i8.StaticTimelineDemoComponent> = i1.ɵccf('ng-component',
    i8.StaticTimelineDemoComponent,View_StaticTimelineDemoComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./$$_gendir/src/app/static-timeline/static-timeline-demo.component.ngfactory.ts